import { useEffect, useState, useRef } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import Paginator from "../../shared/Paginator";
import api from "../../services/api";
import NoDataFound from "../../shared/NoDataFound";
import { useTableState } from "./utils/useTableState";
import { alphaformatDateTime } from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import config from "../../config";
import VersionsRow from "./components/VersionsRow";
import UploadModal from "./components/UploadModal";
import { Toast } from "../../shared/Toast";
import Loader from "../../shared/Loader";
import { chat, timeline, version as versionIcon, more, view_latest_design, view_ad_detauls } from "../../assets/svg";
import ContentDrawer from "./components/ContentDrawer";
import ImageModal from "./components/ImageModal";
import TimelineModal from "./components/TimelineModal";
import ContentDetailsCell from "./components/ContentDetailsCell";
import ImagesModal from "./components/ImagesModal";

const CompleteAds = ({
  completeDesigns,
  activechild,
  loader,
  currentPage,
  setCurrentPage,
  handlePageChange,
  completeselectedtab,
  setcompleteselectedtab,
  NotAcceptedCount,
  AcceptedCount,
}) => {
  const { expandedVersionsRow, actionHandlers, closeExpandedRows, drawer, setModal, modal } = useTableState();

  const fileInputRefs = useRef({});
  const [uploadingidx, setIsUploadingidx] = useState(null);
  const [selectedCreative, setSelectedCreative] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showImages, setShowImages] = useState({ open: false, adData: null });

  const [showActionsMenu, setShowActionsMenu] = useState(-1);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showActionsMenu !== -1) {
        const actionsMenus = document.querySelectorAll("[data-actions-menu]");
        let clickedOutside = true;
        actionsMenus.forEach((menu) => {
          if (menu.contains(event.target)) clickedOutside = false;
        });
        if (clickedOutside) setShowActionsMenu(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showActionsMenu]);

  const handleUploadClick = (creativeId, creativeType, idx) => {
    setSelectedCreative({ id: creativeId, type: creativeType, idx });
    setShowUploadModal(true);
  };
  const handleUploadSuccess = (result) => {
    setIsUploadingidx(-1);
  };
  const handleUploadError = (error) => {
    console.error("Upload failed:", error);
  };
  const uploadImage = async (formData, idx) => {
    try {
      const res = await api({
        url: "/upload/alphaImage",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.code === 200) {
        Toast("success", res.message);
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Failed to upload file.");
    } finally {
      setIsUploadingidx(null);
    }
  };
  const uploadVideo = async (creative_type, formData, idx) => {
    try {
      const res = await api({
        url: "/upload/alphaVideo",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.code === 200) {
        Toast("success", res.message);
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Failed to upload file.");
    } finally {
      setIsUploadingidx(null);
    }
  };
  const uploadPromotedImage = async (creative_type, formData, idx) => {
    try {
      const res = await api({
        url: "/upload/alphaPromtedImage",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.code === 200 || res.code === 204) {
        Toast("success", res.message);
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Failed to upload file.");
    } finally {
      setIsUploadingidx(null);
    }
  };
  const handleFileChange = async (creative_id, creative_type, event, idx) => {
    const file = event.target.files[0];
    if (!file) {
      Toast("error", "No file selected.");
      return;
    }
    const formData = new FormData();
    formData.append("files", file);
    formData.append("creative_id", creative_id);
    setIsUploadingidx(idx);
    if (creative_type === "full_image" || creative_type === "full_page") {
      uploadImage(creative_type, formData, idx);
    } else if (creative_type === "full_video" || creative_type==='promoted_video_story') {
      uploadVideo(creative_type, formData, idx);
    } else {
      uploadPromotedImage(creative_type, formData, idx);
    }
  };
  useEffect(() => {
    setCurrentPage(0);
  }, [activechild]);

  return (
    <div>
      <div>
        <div className="sticky flex gap-4 mb-4">
          <button className={`px-4 py-2 rounded ${completeselectedtab === "Pending_Approval" ? "bg-blue-600 text-white" : "bg-gray-200"}`} onClick={() => setcompleteselectedtab("Pending_Approval")}>
            Pending For Aprovals <span className="text-black mx-1 py-1 px-2 bg-gray-200 rounded-full">{NotAcceptedCount}</span>
          </button>
          <button className={`px-4 py-2 rounded ${completeselectedtab === "Aproved" ? "bg-blue-600 text-white" : "bg-gray-200"}`} onClick={() => setcompleteselectedtab("Aproved")}>
            Aproved<span className="text-black mx-1 py-1 px-2 bg-white rounded-full">{AcceptedCount}</span>
          </button>
        </div>
      </div>
      <div>
        <ScrollContainer>
          <table className="table table-bordered">
            <thead>
              <tr className="bg-gray-100">
                {/* <th className="p-2 text-left">Sales Person Details</th> */}
                {/* <th>Ad Creation Date</th>
              <th>Brand</th> */}
                <th>Campaign Name</th>
                {/* <th>Start Date</th> */}
                {/* <th>End Date</th> */}
                <th>Ad Type</th>
                <th>Adops</th>
                <th>Assign Time</th>
                {/* <th>CompletedTime</th>
              <th>Conversation</th> */}
                <th>Content</th>
                {completeselectedtab == "Pending_Approval" && <th>Upload Design</th>}
                <th>Action</th>
              </tr>
            </thead>
            {completeDesigns.length > 0 && !loader ? (
              completeDesigns.map((row, idx) => {
                const created_at = alphaformatDateTime(row.created_at);
                const start_date = alphaformatDateTime(row.creative_start_date);
                const end_date = alphaformatDateTime(row.creative_end_date);
                const assign_date = alphaformatDateTime(row.assigndate);
                const completion_date = alphaformatDateTime(row.completiondate);
                return (
                  <tbody>
                    <tr key={idx} className="border-t">
                      {/* <td className="p-2">
                    <div className="flex items-center gap-1">
                      <sl-icon name="person" />
                      <span>{row.sales_person.sales_person_name}</span>
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <sl-icon name="telephone" />
                      <span>{row.sales_person.mobile}</span>
                    </div>
                  </td> */}
                      {/* <td>
                    <div className='font-bold'>{created_at.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{created_at.timeStr}</div>
                  </td> 
                  <td>{row.brand_name}</td> */}
                      <td>
                        {row.creative_name}
                        <button className="p-1 m-1 bg-gray-200 rounded-lg" onClick={() => setModal({ open: true, type: "latestDesign", image: row.latest_design })}>
                          img
                        </button>
                      </td>
                      {/* <td className="p-2">
                    <div className='font-bold'>{start_date.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{start_date.timeStr}</div>
                  </td> */}
                      {/* <td className="p-2">
                    <div className='font-bold'>{end_date.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{end_date.timeStr}</div>
                  </td> */}
                      <td>{row.ad_creative_sub_type}</td>
                      <td>{row.cst_name}</td>
                      <td className="p-2 font-bold">
                        <div>{assign_date.dateStr}</div>
                        <div className="text-xs text-gray-500">{assign_date.timeStr}</div>
                      </td>
                      {/* <td className="p-2 font-bold">
                    <div>{completion_date.dateStr}</div>
                    <div className="text-xs text-gray-500">{completion_date.timeStr}</div>
                  </td> */}
                      {/* <td>
                    <button className="bg-blue-600 text-white px-5 py-1 rounded">
                      logs
                    </button>
                  </td> */}

                      <td>
                        <ContentDetailsCell creative_id={row.creative_id} />
                      </td>

                      {completeselectedtab === "Pending_Approval" && (
                        <td>
                          <input type="file" ref={(el) => (fileInputRefs.current[idx] = el)} onChange={(e) => handleFileChange(row.creative_id, row.creative_type, e, idx)} className="hidden" />
                          {uploadingidx === idx ? (
                            <Loader />
                          ) : (
                            <button
                              className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition-colors"
                              onClick={() => handleUploadClick(row.creative_id, row.ad_creative_sub_type, idx)}
                            >
                              Upload Design
                            </button>
                          )}
                        </td>
                      )}

                      <td className="flex justify-center relative">
                        {showActionsMenu === idx && (
                          <div className="absolute z-10 top-0 right-full flex gap-3 items-center justify-center bg-gray-600  border rounded-md py-2 px-3 space-x-2 w-48" data-actions-menu>
                            <sl-tooltip content="viewLatestDesign" hoist>
                              <img
                                src={view_latest_design}
                                onClick={() => {
                                  actionHandlers["viewLatestDesign"](row);
                                }}
                                alt="viewLatestDesign"
                                className="w-6 h-6 inline-block cursor-pointer"
                              />
                            </sl-tooltip>
                            <sl-tooltip content="version" hoist>
                              <img
                                src={versionIcon}
                                onClick={() => {
                                  actionHandlers["toggleVersions"](idx, expandedVersionsRow);
                                }}
                                alt="version"
                                className="w-6 h-6 inline-block cursor-pointer"
                              />
                            </sl-tooltip>
                            <sl-tooltip content="viewTimeline" hoist>
                              <img
                                src={timeline}
                                onClick={() => {
                                  actionHandlers["viewTimeline"](row);
                                }}
                                alt="viewTimeline"
                                className="w-6 h-6 inline-block cursor-pointer"
                              />
                            </sl-tooltip>
                            <sl-tooltip content="View Images" hoist>
                              <img src={view_ad_detauls} onClick={() => setShowImages({ open: true, adData: row })} alt="viewAdDetails" className="w-6 h-6 inline-block cursor-pointer" />
                            </sl-tooltip>
                          </div>
                        )}
                        {
                          <sl-tooltip content="More actions" hoist>
                            <img src={more} alt="More" className={`w-5 h-5 ${showActionsMenu !== idx ? "rotate-90" : ""}`} onClick={() => setShowActionsMenu((ind) => (ind == idx ? -1 : idx))} />
                          </sl-tooltip>
                        }
                      </td>
                    </tr>
                    <VersionsRow row={row} isExpanded={expandedVersionsRow === idx} colSpan={12} onClose={() => closeExpandedRows()} />
                  </tbody>
                );
              })
            ) : !completeDesigns.length > 0 && !loader ? (
              <NoDataFound colspan="11" />
            ) : (
              <TableLoader colspan="12" />
            )}
          </table>
        </ScrollContainer>
        <div className="flex justify-end">
          {completeselectedtab == "Pending_Approval" && Math.ceil(NotAcceptedCount / config.PER_PAGE) > 1 && (
            <Paginator pageCount={Math.ceil(NotAcceptedCount / config.PER_PAGE)} handlePageClick={handlePageChange} forcePage={currentPage} />
          )}
          {completeselectedtab == "Aproved" && Math.ceil(AcceptedCount / config.PER_PAGE) > 1 && (
            <Paginator pageCount={Math.ceil(AcceptedCount / config.PER_PAGE)} handlePageClick={handlePageChange} forcePage={currentPage} />
          )}
        </div>

        <ImageModal isOpen={modal?.open && modal?.type === "latestDesign"} image={modal?.image} alt="alt image" onClose={actionHandlers.closeModal} row={modal?.row} />
        <TimelineModal isOpen={modal?.open && modal?.type === "timeline"} row={modal?.timelineData} onClose={actionHandlers.closeModal} />
        <ContentDrawer isOpen={drawer?.open} type={drawer?.type} rowData={drawer?.rowData} onClose={actionHandlers.closeDrawer} />
        <UploadModal
          isOpen={showUploadModal}
          onClose={() => setShowUploadModal(false)}
          onUploadSuccess={handleUploadSuccess}
          onUploadError={handleUploadError}
          creativeId={selectedCreative?.id}
          creativeType={selectedCreative?.type}
        />
        <ImagesModal isOpen={showImages.open} adData={showImages.adData} onClose={() => setShowImages({ open: false, adData: null })} />
      </div>
    </div>
  );
};

export default CompleteAds;
